import { getSession } from '@auth0/nextjs-auth0';
import { SignupHeader } from '@summer-health/ui/care-signup';
import { GetServerSidePropsResult } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { SignupLayout } from '../../../components/shared/signup-layout';
import { PartnershipWelcomePage } from '../../../components/welcome/page';
import { UserQuery } from '../../../queries/user-query';
import { serverClient } from '../../../utils/apollo';
import { getAccessTokenOrRedirect } from '../../../utils/user';

export default function WelcomeIndexPage({
  slug,
}: {
  slug: string;
}): JSX.Element {
  return <PartnershipWelcomePage slug={slug} />;
}

export const getServerSideProps = async (
  ctx,
): Promise<GetServerSidePropsResult<object>> => {
  const session = await getSession(ctx.req, ctx.res);
  if (session) {
    // Session means user is 'logged in'
    // Need to validate if they're a new user or if they've
    // already completed this step.
    const { accessToken, redirect } = await getAccessTokenOrRedirect(ctx);
    if (redirect) {
      return {
        redirect,
      };
    }

    const { data } = await serverClient.query({
      context: {
        headers: {
          authorization: `Bearer ${accessToken}`,
        },
      },
      query: UserQuery,
    });

    return {
      props: {
        user: data.user,
        slug: ctx.params.slug,
        ...(await serverSideTranslations(ctx.locale, ['common'])),
      },
    };
  }

  return {
    props: {
      slug: ctx.params.slug,
      ...(await serverSideTranslations(ctx.locale, ['common'])),
    },
  };
};

WelcomeIndexPage.getLayout = function getLayout(
  page: JSX.Element,
  pageProps,
): JSX.Element {
  return (
    <SignupLayout header={<SignupHeader />} {...pageProps}>
      {page}
    </SignupLayout>
  );
};
